<template>
  <section style="padding: 30px;">
    <div class="container pc-only" style="padding: 0px;">
      <carousel :navigationEnabled="true" :perPage="4" :paginationEnabled="false">
        <div v-if="isLoaded && (!activities || activities.length === 0)" style="text-align:center; padding: 2em 0;">
          활동이 없습니다.
        </div>

  <slide class="col-lg-3 col-md-4 col-sm-6 slides" v-else v-for="activity in activities"> <!--  carousel-item active -->
          <div class="card h-100">
            <router-link :to="{name : 'activitySearch', params : { size:'10', page:'0', category:activity.category, query:`category:${activity.category}` }}" >
              <span class="notify-badge" :style="'background-color:'+activity.categoryColor">{{activity.categoryName}}</span>
            </router-link>
            <router-link :to="{name : 'activityShow', params : { id : activity.id }}" style="max-height: 300px;">
              <img class="card-img-top" :src="activity.thumbnail" alt="" @error="activity.thumbnail = require('@/assets/icon/'+activity.categoryClazz+'_on.png')">
            </router-link>
            <div class="card-body">
              <h4 class="card-txt overflow-title" :title="activity.title">
                <router-link :to="{name : 'activityShow', params : { id : activity.id }}">{{activity.title}}</router-link>
              </h4>
              <p class="card-text text-danger">{{activity.memberCount}}명 / {{activity.joinAblePersonCount}}명</p>
              <p class="card-text">{{activity.visibleAddressToJoinerOnly ? '신청자 공개' : activity.activityPlaceName}}</p>
              <p class="card-text">{{$root.$children[0].dateFormat(activity.activityStartDate, 'YYYY.MM.DD')}} ~ {{$root.$children[0].dateFormat(activity.activityEndDate, 'MM.DD')}}<br>
                {{$root.$children[0].dateFormat(activity.activityStartDate, 'HH:mm')}} ({{parseInt(activity.volunteerMinute/60)}}h)</p>
            </div>
          </div>
        </slide>
      </carousel>
    </div>


    <div class="container mobile-only" style="padding: 0px;">
      <carousel :navigationEnabled="true" :perPage="2" :paginationEnabled="false">
        <div class="card text-white bg-secondary my-5 py-4 text-center" v-if="!!!activities">
          <div class="card-body">
            <p class="text-white m-0">“활동이 없습니다.”</p>
          </div>
        </div>

        <slide class="col-lg-3 col-md-4 col-sm-6 slides" v-else v-for="activity in activities"> <!--  carousel-item active -->
          <div class="card h-100">
            <router-link :to="{name : 'activitySearch', params : { size:'10', page:'0', category:activity.category, query:`category:${activity.category}` }}" >
              <span class="notify-badge" :style="'background-color:'+activity.categoryColor">{{activity.categoryName}}</span>
            </router-link>
            <router-link :to="{name : 'activityShow', params : { id : activity.id }}">
              <img class="card-img-top" :src="activity.thumbnail" alt="">
            </router-link>
            <div class="card-body">
              <h4 class="card-txt overflow-title" :title="activity.title">
                <router-link :to="{name : 'activityShow', params : { id : activity.id }}">{{activity.title}}</router-link>
              </h4>
              <p class="card-text text-danger">{{activity.memberCount}}명 / {{activity.joinAblePersonCount}}명</p>
              <p class="card-text">{{activity.visibleAddressToJoinerOnly ? '신청자 공개' : activity.activityPlaceName}}</p>
              <p class="card-text">{{$root.$children[0].dateFormat(activity.activityStartDate, 'YYYY.MM.DD')}} ~ {{$root.$children[0].dateFormat(activity.activityEndDate, 'MM.DD')}}<br>
                {{$root.$children[0].dateFormat(activity.activityStartDate, 'HH:mm')}} ({{parseInt(activity.volunteerMinute/60)}}h)</p>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </section>

</template>

<script>
  import { Carousel, Slide } from 'vue-carousel';
  /* eslint-disable */
  export default {
    name: 'ActivityList',
    data() {
      return {
        activities : [],
        search: {},
        isLoaded: false,
      }
    },
    components: {
      Carousel,
      Slide,
    },
    props: {
      query: String,
      page: String,
      size: String,
      target: String,
      value: String,
      category: String,
      interMemberId: Number ,
      registMemberId: Number ,
    },
    methods: {
      searchSubmit(search) {
        this.search = search;
        this.getList();
      },
      getList() {
        let me = this;
        let u = new URLSearchParams(this.search).toString();

        let url = process.env.VUE_APP_PUBLIC_API_URL + `/activity/list/search?${u}`;

        if(!!this.interMemberId) url = process.env.VUE_APP_PUBLIC_API_URL + `/activity/list/member/interested/${this.$auth.user().id}?${u}`;
        else if(!!this.registMemberId) url = process.env.VUE_APP_PUBLIC_API_URL + `/activity/list/member/registered/${this.$auth.user().id}?${u}`;
        //console.log(u);
        this.axios.get(url)
          .then(function (res) {
            me.activities = res.data;
            me.isLoaded = true;
          }).catch(function (error) {
            me.isLoaded = true;
            console.log(error);
          });
      },
    },
    mounted() {
      this.getList();
    },
    created() {
      //console.log(this.$route.params)
      this.search.page = !!this.$route.params.page ? this.$route.params.page : this.$props.page
      this.search.size = !!this.$route.params.size ? this.$route.params.size : this.$props.size
      this.search.query = !!this.$route.params.query ? this.$route.params.query : this.$props.query
    },

    watch : {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .item {
    position:relative;
    padding-top:10px;
    display:inline-block;
  }
  .notify-badge{
    position: absolute;
    left:10px;
    top:10px;
    text-align: center;
    border-radius: 15px;
    color:white;
    padding:5px 10px;
    font-size:20px;
  }

  .card-body h4{
    font-size:18px;
  }

  .card-body p.card-text.text-danger{
    font-size: 14px;
    color:#7fb7e8!important;
    }

  .card-body a{
    color:#282828;
  }

  .card span{
    font-size:13px;
    font-weight: bold;
  }

  .slides {
    padding: 0px
  }

  .card-text{
    color:#707070!important;
    font-size: 15px;
  }

  .card-text-p{
    color:#707070!important;
    font-size: 14px;
  }


  @media(max-width: 576px) {
    .slides {
      padding: 5px
    }
    .card-body{
      padding: 0.75rem;
    }
  }
  @media(min-width: 1199.98px) {
    .slides:not(:nth-child(4)):not(:nth-child(8)) {
      /*padding-right: 10px*/
    }
    .slides {
      padding:5px;
    }
  }
  .overflow-title{
    overflow: hidden;
    max-height: 40px;
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .carousel-indicators,
  .carousel-indicators li {
    cursor: default;
    pointer-events: none;
  }


</style>
